import axios from "axios";


/**
 * @param {String} exportarCsvURL
 * @returns {Promise}
 *
 * Realiza un request para solicitar los datos del gráfico diario
 */

 export default function getReporte(exportarCsvURL) {
    return new Promise((resolve, reject) => {

        axios
            .get(exportarCsvURL, {
                responseType: 'blob', // Especifica que la respuesta es un archivo binario (PDF)
            })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                // Crea un enlace temporal y simula un clic para descargar el archivo
                const a = document.createElement('a');
                a.href = url;
                a.download = 'reportes_servicios.csv'; // Puedes cambiar el nombre del archivo aquí
                a.style.display = 'none';
                a.id = 'link-descarga-archivo';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);

                const enlace = document.getElementById('link-descarga-archivo');
                if (enlace) {
                    document.body.removeChild(enlace);
                }

                resolve();
            })
            .catch((error) => {
                reject();
            });

    })
}
